/*
创建者 李伟(2018.3.11)
*/
<template>
  <div class="conInner">
    <section id="content_wrapper">
      <div class="data">
        <h2>我的咨询</h2>
      </div>
      <div class="tip">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg">
          <div>
            <h2>温馨提示</h2>
            <p>1、这里将显示您的咨询信息。</p>
            <p>2、您还可以查看您的咨询信息以及管理员的回复等。</p>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <div class="tab">
        <ul>
          <li class="selected"><a><span>我的咨询</span></a></li>
        </ul>
      </div>
      <div class="box">
        <div class="top"></div>
        <div class="body">
          <div class="empty" v-if="!askList.length">暂无信息</div>
          <table cellspacing="0" cellpadding="3" class="liststyle" style="width: 100%" v-if="askList.length">
            <tbody>
              <tr>
                <th style="width: 60%">咨询商品</th>
                <th style="width: 40%">提交时间</th>
              </tr>
            </tbody>
            <tbody>
              <tr class="hovertr" v-for="row in askList">
                <td colspan="2" align="left">
                  <div class="infotop" style="height:31px;border-bottom: 1px solid #dbdbdb;">
                    <div style="width: 60%;float: left">
                      <router-link :to="{ path: '/goods', query: { goods_id: row.goods_id}}" v-bind:title="row.name">
                        {{row.name}}
                      </router-link>
                    </div>
                    <div style="width: 40%;float: left">{{row.dateline}}</div>
                  </div>
                  <div style="clear: both;text-align: left;    padding: 20px 20px 10px;">
                    <h2>您的咨询：</h2>
                    <div>
                      <p style="word-wrap:break-word; word-break:break-all;" v-html="row.content"></p>
                    </div>
                    <h2 v-if="row.reply">回复：</h2>
                    <div v-if="row.reply">
                      <p style="word-wrap:break-word; word-break:break-all;" v-html="row.reply"></p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pager_border" v-if="askList.length">
            <Page ref="pages" :total="dataTotal" show-total :page-size="pageSize" @on-change="changepage" size="small"
              show-elevator></Page>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
    </section>
  </div>
</template>
<script>
import { getaskList } from 'api/user.js';
export default {
  data() {
    return {
      dataTotal: 0,
      pageSize: 10,
      askList: []
    }
  },
  created() {
    this.getaskList(1);
  },
  methods: {
    getDate: function (num) {
      var newDate = new Date();
      newDate.setTime(num * 1000);
      return newDate.toLocaleDateString();
    },
    changepage(index) {
      this.$refs['pages'].currentPage = index;
      this.getaskList(index);
    },
    getaskList: function (pageNo) {
      let _params = {
        'pageNo': pageNo,
        'pageSize': this.pageSize
      }
      getaskList(_params).then((json) => {
        if (json.resCode == '1') {
          this.askList = json.data.list;
          for (var i in this.askList) {
            this.askList[i].dateline = this.getDate(this.askList[i].dateline);
          }
          this.dataTotal = json.data.total;
        } else {
          this.$Message.error(json.resDesc);
        }
      });
    }

  }
}
</script>



// WEBPACK FOOTER //
// myAdvice.vue?6c7c5701